import { render, staticRenderFns } from "./success-popup.component.vue?vue&type=template&id=467988c4&"
import script from "./success-popup.component.ts?vue&type=script&lang=ts&"
export * from "./success-popup.component.ts?vue&type=script&lang=ts&"
import style0 from "./success-popup.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports